import type { Config } from '@/types/config'

export const basePath = ''
export const apiBasePath = '/user/digital_products'
export const humanName = {
  singular: 'Evento',
  plural: 'Eventos'
}

interface GetConfigProps {
  id?: string
}

export const getConfig = ({ id = '' }: GetConfigProps): Config => {
  const normalizedId = id ? id.replace(/^\/+/, '') : ''

  const config: Config = {
    basePathWithId: normalizedId ? `${basePath}/${normalizedId}` : basePath,
    basePath,
    apiBasePath,
    apiBasePathWithId: normalizedId
      ? `${apiBasePath}/${normalizedId}`
      : apiBasePath,
    humanName
  }

  return config
}
